<div class="myspace">
  <div class="myspace__inner">
    <header class="myspace__head" *ngIf="!showDetail">
      <h1>Mon espace</h1>
      <p>Retrouvez vos polices, devis et prestations.</p>
    </header>

    <nav class="myspace-tabs" *ngIf="!showDetail" aria-label="Sections de Mon espace">
      <span class="myspace-tabs__indicator" [style.transform]="tabIndicatorTransform"></span>
      <button
        type="button"
        class="myspace-tabs__btn"
        *ngFor="let tab of tabs"
        [class.myspace-tabs__btn--active]="activeTab === tab.id"
        (click)="selectTab(tab.id)">
        <mat-icon>{{ tab.icon }}</mat-icon>
        <span>{{ tab.label }}</span>
      </button>
    </nav>

    <ng-container *ngIf="!showDetail">
      <section class="myspace-panel" *ngIf="activeTab === 'polices'">
        <div class="myspace-summary" *ngIf="!policiesLoading && !policiesError">
          <article class="summary-card">
            <mat-icon>verified_user</mat-icon>
            <div>
              <span>Polices</span>
              <strong>{{ policies.length }}</strong>
            </div>
          </article>
          <article class="summary-card summary-card--accent">
            <mat-icon>category</mat-icon>
            <div>
              <span>Produits</span>
              <strong>{{ policyProductCount }}</strong>
            </div>
          </article>
        </div>

        <div class="myspace-state" *ngIf="policiesLoading">
          <mat-spinner diameter="36"></mat-spinner>
          <p>Chargement des polices…</p>
        </div>
        <div class="myspace-state myspace-state--error" *ngIf="!policiesLoading && policiesError">
          <p>{{ policiesError }}</p>
          <button type="button" mat-stroked-button color="primary" (click)="reload()">Réessayer</button>
        </div>
        <div class="myspace-state" *ngIf="!policiesLoading && !policiesError && !policies.length">
          Aucune police disponible
        </div>

        <ng-container *ngFor="let group of policyGroups">
          <h2 class="myspace-group" *ngIf="group.name">{{ group.name }}</h2>
          <article class="space-card" *ngFor="let policy of group.items" (click)="openPolicy(policy)">
            <div class="space-card__top">
              <span class="space-card__icon">
                <img *ngIf="policyImage(policy)" [src]="policyImage(policy)" alt="" (error)="onImageError($event)" />
                <mat-icon *ngIf="!policyImage(policy)">shield</mat-icon>
              </span>
              <div class="space-card__copy">
                <strong>{{ policyProductName(policy) }}</strong>
                <small>N° {{ contractNumber(policy) }}</small>
              </div>
              <span class="space-card__badge" [attr.data-tone]="statusTone(policyStatus(policy))">
                {{ policyStatus(policy) }}
              </span>
            </div>
            <div class="space-card__meta">
              <div>
                <span>Date d'effet</span>
                <strong>{{ policyEffectDate(policy) }}</strong>
              </div>
              <div class="space-card__meta-end">
                <span>Date échéance</span>
                <strong>{{ policyEndDate(policy) }}</strong>
              </div>
            </div>
          </article>
        </ng-container>
      </section>

      <section class="myspace-panel" *ngIf="activeTab === 'devis'">
        <div class="myspace-summary" *ngIf="!devisLoading && !devisError">
          <article class="summary-card">
            <mat-icon>description</mat-icon>
            <div>
              <span>Devis</span>
              <strong>{{ devisCount }}</strong>
            </div>
          </article>
          <article class="summary-card summary-card--accent">
            <mat-icon>category</mat-icon>
            <div>
              <span>Produits</span>
              <strong>{{ devisGroups.length }}</strong>
            </div>
          </article>
        </div>

        <div class="myspace-state" *ngIf="devisLoading">
          <mat-spinner diameter="36"></mat-spinner>
          <p>Chargement des devis…</p>
        </div>
        <div class="myspace-state myspace-state--error" *ngIf="!devisLoading && devisError">
          <p>{{ devisError }}</p>
          <button type="button" mat-stroked-button color="primary" (click)="reload()">Réessayer</button>
        </div>
        <div class="myspace-state" *ngIf="!devisLoading && !devisError && !devisCount">
          Aucun devis disponible !
        </div>

        <ng-container *ngFor="let group of devisGroups">
          <h2 class="myspace-group" *ngIf="group.name">{{ group.name }}</h2>
          <article class="space-card" *ngFor="let devis of group.items" (click)="openDevis(devis)">
            <div class="space-card__top">
              <span class="space-card__icon">
                <img *ngIf="devis.projectUrlImage" [src]="devis.projectUrlImage" alt="" (error)="onImageError($event)" />
                <mat-icon *ngIf="!devis.projectUrlImage">description</mat-icon>
              </span>
              <div class="space-card__copy">
                <strong>{{ devisProductName(devis) }}</strong>
                <small>{{ devisGuarantees(devis) }}</small>
              </div>
              <button
                type="button"
                class="space-card__dismiss"
                (click)="confirmDeleteDevis(devis, $event)"
                [disabled]="deletingDevis"
                aria-label="Supprimer le devis">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <div class="space-card__meta">
              <div>
                <span>Date du devis</span>
                <strong>{{ formatDateTime(devis.createdAt) }}</strong>
              </div>
              <div class="space-card__meta-end">
                <span>Montant à payer</span>
                <strong class="space-card__amount">{{ devisAmount(devis) }}</strong>
              </div>
            </div>
          </article>
        </ng-container>
      </section>

      <section class="myspace-panel" *ngIf="activeTab === 'prestations'">
        <div class="myspace-summary" *ngIf="!sinistersLoading && !sinistersError">
          <article class="summary-card summary-card--accent">
            <mat-icon>pending_actions</mat-icon>
            <div>
              <span>En cours</span>
              <strong>{{ sinisterInProgressCount }}</strong>
            </div>
          </article>
          <article class="summary-card">
            <mat-icon>check_circle</mat-icon>
            <div>
              <span>Clôturées</span>
              <strong>{{ sinisterClosedCount }}</strong>
            </div>
          </article>
        </div>

        <div class="myspace-state" *ngIf="sinistersLoading">
          <mat-spinner diameter="36"></mat-spinner>
          <p>Chargement des prestations…</p>
        </div>
        <div class="myspace-state myspace-state--error" *ngIf="!sinistersLoading && sinistersError">
          <p>{{ sinistersError }}</p>
          <button type="button" mat-stroked-button color="primary" (click)="reload()">Réessayer</button>
        </div>
        <div class="myspace-state" *ngIf="!sinistersLoading && !sinistersError && !hasSinisters">
          Aucune prestation disponible
        </div>

        <ng-container *ngFor="let group of sinisterGroups">
          <h2 class="myspace-group" *ngIf="group.name">{{ group.name }}</h2>
          <article class="space-card" *ngFor="let sinister of group.items" (click)="openSinister(sinister)">
            <div class="space-card__top">
              <span class="space-card__icon">
                <img *ngIf="sinister.typeIconeUrl" [src]="sinister.typeIconeUrl" alt="" (error)="onImageError($event)" />
                <mat-icon *ngIf="!sinister.typeIconeUrl">medical_services</mat-icon>
              </span>
              <div class="space-card__copy">
                <strong>{{ sentenceCase(sinister.claimNaming || 'Prestation') }}</strong>
                <small>Réf. : {{ sinister.reference || '-' }}</small>
              </div>
              <span class="space-card__badge" [attr.data-tone]="sinisterStatusTone(sinister.status)">
                {{ sinisterStatusLabel(sinister.status) }}
              </span>
            </div>
            <div class="space-card__meta">
              <div>
                <span>Date de prestation</span>
                <strong>{{ formatDateTime(sinister.createdAt) }}</strong>
              </div>
              <div class="space-card__meta-end" *ngIf="sinisterPoliceNumber(sinister)">
                <span>N° police</span>
                <strong>{{ sinisterPoliceNumber(sinister) }}</strong>
              </div>
            </div>
          </article>
        </ng-container>
      </section>
    </ng-container>

    <section class="myspace-detail" *ngIf="showDetail">
      <header class="myspace-detail__head">
        <button type="button" class="myspace-detail__back" (click)="onDetailBack()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1>{{ detailTitle }}</h1>
      </header>

      <article class="detail-hero" *ngIf="showPolicyOverview && selectedPolicy as policy">
        <span class="detail-hero__icon">
          <img *ngIf="policy.policyUrlImage" [src]="policy.policyUrlImage" alt="" (error)="onImageError($event)" />
          <mat-icon *ngIf="!policy.policyUrlImage">shield</mat-icon>
        </span>
        <div class="detail-hero__copy">
          <strong>{{ contractNumber(policy) }}</strong>
          <small>Du {{ policyEffectDate(policy) }} au {{ policyEndDate(policy) }}</small>
          <p class="detail-hero__prime">Prime : {{ policyPrime(policy) }}</p>
        </div>
        <div class="detail-hero__aside">
          <span class="space-card__badge" [attr.data-tone]="statusTone(policyStatus(policy))">{{ policyStatus(policy) }}</span>
          <button
            type="button"
            class="recap-doc-btn"
            *ngIf="canDownloadPolicyCp"
            (click)="downloadPolicyCp()"
            [disabled]="cpDownloading"
            aria-label="Télécharger les conditions particulières">
            <span class="recap-doc-btn__icon" aria-hidden="true">PDF</span>
            <span class="recap-doc-btn__label">{{ cpDownloading ? '…' : 'CP.' }}</span>
          </button>
        </div>
      </article>

      <section class="policy-pay-form" *ngIf="showPolicyPaymentForm && policyPayment">
        <h2>Procéder au paiement</h2>

        <div
          class="policy-pay-field"
          *ngIf="policyPayment.isFreePay"
          [class.policy-pay-field--error]="!!policyPayFreeError">
          <div class="policy-pay-field__box">
            <input
              id="policy-pay-amount"
              type="text"
              inputmode="decimal"
              placeholder=" "
              [value]="policyPayFreeAmount"
              (input)="onPolicyPayFreeAmountInput(inputValue($event))"
              (blur)="onPolicyPayFieldBlur()" />
            <label class="policy-pay-field__label" for="policy-pay-amount">Montant à payer</label>
            <span class="policy-pay-field__suffix">{{ currency }}</span>
          </div>
          <small class="policy-pay-field__error" *ngIf="policyPayFreeError">{{ policyPayFreeError }}</small>
        </div>

        <ng-container *ngIf="!policyPayment.isFreePay">
          <div class="policy-pay-field" [class.policy-pay-field--error]="!!policyPayPeriodsError">
            <div class="policy-pay-field__box">
              <input
                id="policy-pay-periods"
                type="text"
                inputmode="numeric"
                placeholder=" "
                [value]="policyPayPeriods"
                (input)="onPolicyPayPeriodsInput(inputValue($event))"
                (blur)="onPolicyPayFieldBlur()" />
              <label class="policy-pay-field__label" for="policy-pay-periods">{{ policyPeriodsLabel }}</label>
              <span class="policy-pay-field__suffix">#</span>
            </div>
            <small class="policy-pay-field__error" *ngIf="policyPayPeriodsError">{{ policyPayPeriodsError }}</small>
          </div>

          <div class="policy-pay-field">
            <div class="policy-pay-field__box">
              <input id="policy-pay-total" type="text" placeholder=" " [value]="policyPayTotalLabel" readonly />
              <label class="policy-pay-field__label" for="policy-pay-total">Montant total à payer</label>
              <span class="policy-pay-field__suffix">{{ currency }}</span>
            </div>
          </div>
        </ng-container>

        <button type="button" class="btn btn--primary policy-pay-form__submit" (click)="validatePolicyPayment()">
          Valider
        </button>
      </section>

      <div class="policy-pay-overlay" *ngIf="policyPayValidating" role="status" aria-live="polite">
        <span class="detail-body__dots" aria-hidden="true"></span>
      </div>

      <div class="detail-payment" *ngIf="showPolicyPaymentWidget">
        <p class="recap-info" *ngIf="validatingPolicyPayment">Enregistrement de l’encaissement…</p>
        <app-subscription-payment
          *ngIf="!validatingPolicyPayment"
          [amount]="policyPayAmount"
          [currencyLabel]="currency"
          [policyNumber]="policyPayPolicyNumber"
          [productId]="policyProduct?.id || ''"
          [productName]="selectedPolicy?.productName || policyProduct?.name || ''"
          [description]="policyPayment?.description || 'paiement cotisation'"
          (paymentCompleted)="onPolicyPaymentCompleted($event)">
        </app-subscription-payment>
      </div>

      <div class="detail-body" *ngIf="showPolicyOverview">
        <div class="detail-body__loader" *ngIf="policyDetailLoading" role="status" aria-live="polite">
          <span class="detail-body__dots" aria-hidden="true"></span>
          <p>Chargement du détail…</p>
        </div>

        <p class="detail-empty" *ngIf="policyDetailError && !policyDetailLoading">
          {{ policyDetailError }}
          <button type="button" class="detail-retry" (click)="retryPolicyDetail()">Réessayer</button>
        </p>

        <ng-container *ngIf="!policyDetailLoading && !policyDetailError">
      <mat-accordion class="recap-accordion" multi="false">
        <mat-expansion-panel
          class="recap-panel-item"
          *ngFor="let section of policyAccordionSections; let first = first"
          [expanded]="first && (section.rows?.length || section.guarantees?.length || section.people?.length || 0) < 24">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="recap-panel-item__bar" aria-hidden="true"></span>
              {{ section.title }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container [ngTemplateOutlet]="sectionTpl" [ngTemplateOutletContext]="{ $implicit: section }"></ng-container>
        </mat-expansion-panel>
      </mat-accordion>

      <div
        class="policy-super-actions__backdrop"
        *ngIf="openSuperActionId"
        (click)="closeSuperActionMenu()"></div>

      <div class="policy-super-actions" *ngIf="policySuperActions.length">
        <div class="policy-super-action" *ngFor="let superAction of policySuperActions">
          <div
            class="policy-super-action__menu"
            *ngIf="openSuperActionId === superActionId(superAction)"
            (click)="$event.stopPropagation()">
            <button
              type="button"
              class="policy-super-action__menu-item"
              *ngFor="let action of superAction.actions || []"
              (click)="onPolicyAction(action, $event)">
              <span>{{ sentenceCase(action.label || action.name || '') }}</span>
              <span class="policy-super-action__menu-icon">
                <span class="policy-super-action__icon policy-super-action__icon--sm" *ngIf="action.image?.url as actionIcon">
                  <img [src]="actionIcon" alt="" (error)="onImageError($event)" />
                  <span
                    class="policy-super-action__glyph policy-super-action__glyph--light"
                    [ngStyle]="tintedIconStyle(actionIcon)"></span>
                </span>
                <mat-icon *ngIf="!action.image?.url">add</mat-icon>
              </span>
            </button>
          </div>
          <button
            type="button"
            class="policy-super-action__trigger"
            (click)="toggleSuperAction(superAction, $event)"
            [attr.aria-label]="superAction.label || superAction.name">
            <mat-icon *ngIf="openSuperActionId === superActionId(superAction)">close</mat-icon>
            <ng-container *ngIf="openSuperActionId !== superActionId(superAction)">
              <span class="policy-super-action__icon" *ngIf="superAction.image?.url as superIcon">
                <img [src]="superIcon" alt="" (error)="onImageError($event)" />
                <span class="policy-super-action__glyph" [ngStyle]="tintedIconStyle(superIcon)"></span>
              </span>
              <mat-icon *ngIf="!superAction.image?.url">{{ superActionFallbackIcon(superAction) }}</mat-icon>
            </ng-container>
          </button>
          <span class="policy-super-action__label">{{ superActionLabel(superAction) }}</span>
        </div>
      </div>
        </ng-container>
      </div>

      <section class="policy-claim" *ngIf="showPolicyClaimChooser">
        <article class="policy-claim__intro">
          <mat-icon>{{ claimRiskIcon() }}</mat-icon>
          <div>
            <strong>Choix du bénéficiaire</strong>
            <p>Sélectionnez la personne concernée pour continuer</p>
          </div>
        </article>
        <p class="detail-empty" *ngIf="!policyClaimRisks.length">Aucun bénéficiaire disponible</p>
        <button
          type="button"
          class="policy-claim__card"
          *ngFor="let risk of policyClaimRisks"
          (click)="selectClaimRisk(risk)">
          <span class="policy-claim__card-icon">
            <mat-icon>{{ claimRiskIcon() }}</mat-icon>
          </span>
          <span class="policy-claim__card-copy">
            <small>{{ claimRiskLabel() }}</small>
            <strong>{{ claimRiskTitle(risk) }}</strong>
          </span>
          <mat-icon>chevron_right</mat-icon>
        </button>
      </section>

      <app-policy-claim-form
        *ngIf="showPolicyClaimForm && selectedClaimAction"
        [action]="selectedClaimAction"
        [policy]="selectedPolicy"
        [policyDetail]="policyDetail"
        [concern]="selectedClaimConcern"
        [policyNumber]="claimPolicyNumber"
        [typeCode]="claimTypeCode"
        [userId]="claimUserId"
        [currency]="currency"
        (back)="onDetailBack()"
        (completed)="onClaimCompleted()"
        (failed)="onClaimFailed($event)">
      </app-policy-claim-form>

      <article class="detail-hero" *ngIf="selectedDevis as devis">
        <span class="detail-hero__icon">
          <img *ngIf="devis.projectUrlImage" [src]="devis.projectUrlImage" alt="" (error)="onImageError($event)" />
          <mat-icon *ngIf="!devis.projectUrlImage">description</mat-icon>
        </span>
        <div class="detail-hero__copy">
          <strong>{{ devisProductName(devis) }}</strong>
          <small>Devis du {{ formatDateTime(devis.createdAt) }}</small>
          <p class="detail-hero__prime">Prime : {{ devisAmount(devis) }}</p>
        </div>
      </article>

      <mat-accordion class="recap-accordion" multi="false" *ngIf="selectedDevis && !showDevisPayment">
        <mat-expansion-panel
          class="recap-panel-item"
          *ngFor="let section of devisAccordionSections; let first = first"
          [expanded]="first">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="recap-panel-item__bar" aria-hidden="true"></span>
              {{ section.title }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container [ngTemplateOutlet]="sectionTpl" [ngTemplateOutletContext]="{ $implicit: section }"></ng-container>
        </mat-expansion-panel>
      </mat-accordion>

      <div class="detail-actions" *ngIf="selectedDevis && !showDevisPayment">
        <button type="button" class="btn btn--primary" (click)="startDevisPayment()" [disabled]="devisPayAmount <= 0">
          {{ devisPayLabel }}
        </button>
      </div>

      <div class="detail-payment" *ngIf="selectedDevis && showDevisPayment">
        <p class="recap-info" *ngIf="validatingDevisPayment">Validation de la souscription…</p>
        <app-subscription-payment
          *ngIf="!validatingDevisPayment"
          [amount]="devisPayAmount"
          [currencyLabel]="currency"
          [policyNumber]="devisPolicyNumber"
          [productId]="devisProduct?.id || ''"
          [productName]="selectedDevis.productName || devisProduct?.name || ''"
          (paymentCompleted)="onDevisPaymentCompleted($event)">
        </app-subscription-payment>
      </div>

      <article class="detail-hero" *ngIf="selectedSinister as sinister">
        <span class="detail-hero__icon">
          <img *ngIf="sinister.typeIconeUrl" [src]="sinister.typeIconeUrl" alt="" (error)="onImageError($event)" />
          <mat-icon *ngIf="!sinister.typeIconeUrl">medical_services</mat-icon>
        </span>
        <div class="detail-hero__copy">
          <strong>{{ sentenceCase(sinister.claimNaming || 'Prestation') }} du {{ formatDateTime(sinister.createdAt) }}</strong>
          <small>Réf. : {{ sinister.reference || '-' }}</small>
        </div>
        <div class="detail-hero__aside">
          <span class="space-card__badge" [attr.data-tone]="sinisterStatusTone(sinister.status)">
            {{ sinisterStatusLabel(sinister.status) }}
          </span>
          <button
            type="button"
            class="recap-doc-btn"
            *ngIf="canDownloadSinisterAt"
            (click)="downloadSinisterAt()"
            [disabled]="atDownloading"
            aria-label="Télécharger l’attestation">
            <span class="recap-doc-btn__icon" aria-hidden="true">PDF</span>
            <span class="recap-doc-btn__label">{{ atDownloading ? '…' : 'AT.' }}</span>
          </button>
        </div>
      </article>

      <mat-accordion class="recap-accordion" multi="false" *ngIf="selectedSinister">
        <mat-expansion-panel
          class="recap-panel-item"
          *ngFor="let section of sinisterAccordionSections; let first = first"
          [expanded]="first">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="recap-panel-item__bar" aria-hidden="true"></span>
              {{ section.title }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container [ngTemplateOutlet]="sectionTpl" [ngTemplateOutletContext]="{ $implicit: section }"></ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </section>

    <ng-template #sectionTpl let-section>
      <dl class="recap-item-list" *ngIf="section.kind === 'rows'">
        <div class="recap-item" *ngFor="let row of section.rows">
          <dt>{{ row.label }}</dt>
          <dd>{{ row.value }}</dd>
        </div>
      </dl>
      <ul class="detail-guarantees" *ngIf="section.kind === 'guarantees'">
        <li *ngFor="let name of section.guarantees">{{ name }}</li>
      </ul>
      <div class="recap-beneficiary-list" *ngIf="section.kind === 'people'">
        <article class="recap-beneficiary-card" *ngFor="let person of section.people">
          <h3 *ngIf="person.title">{{ person.title }}</h3>
          <dl class="recap-item-list recap-item-list--compact">
            <div class="recap-item" *ngFor="let row of person.rows">
              <dt>{{ row.label }}</dt>
              <dd>{{ row.value }}</dd>
            </div>
          </dl>
        </article>
      </div>
      <div *ngIf="section.kind === 'events'">
        <p class="detail-empty" *ngIf="!section.events?.length">Aucun élément</p>
        <dl class="recap-item-list" *ngIf="section.events?.length">
          <div class="recap-item" *ngFor="let row of section.events">
            <dt>{{ row.label }}</dt>
            <dd>{{ row.value }}</dd>
          </div>
        </dl>
      </div>
    </ng-template>
  </div>

  <div class="myspace-toast" *ngIf="toastMessage" role="status">{{ toastMessage }}</div>
</div>

<app-error-info-modal
  [open]="!!errorModalMessage"
  [message]="errorModalMessage || ''"
  [showRetry]="errorModalCanRetry"
  (closed)="closeErrorModal()"
  (retried)="retryErrorModal()">
</app-error-info-modal>
